import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutTags } from 'uitk-react-layout';
import styles from './uitk-layout-position.css';
import { UitkLayoutPositionTypes, UitkLayoutPositionPointerEvents } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkLayoutPosition = function (props) {
    var children = props.children, className = props.className, cloneElement = props.cloneElement, display = props.display, pointerEvents = props.pointerEvents, position = props.position, style = props.style, tag = props.tag, type = props.type, attributes = __rest(props, ["children", "className", "cloneElement", "display", "pointerEvents", "position", "style", "tag", "type"]);
    var allowCustomPosition = React.useMemo(function () {
        return position &&
            Object.values(position).some(function (v) { return typeof v === 'number'; }) &&
            type === UitkLayoutPositionTypes.get('sticky');
    }, [position, type]);
    var childrenArray = React.Children.toArray(children);
    var firstChild = childrenArray[0];
    if (!firstChild || React.isValidElement(firstChild) === false) {
        return null;
    }
    var firstChildClassName = firstChild.props.className;
    var firstChildStyle = firstChild.props.style;
    var baseClass = 'uitk-layout-position';
    var wrapperClassNames = getClassNameList(baseClass, cloneElement && firstChildClassName && firstChildClassName, display && "".concat(baseClass, "-display-").concat(display), pointerEvents && "".concat(baseClass, "-").concat(UitkLayoutPositionPointerEvents.get(pointerEvents)), position &&
        Object.entries(position)
            .filter(function (_a) {
            var val = _a[1];
            return typeof val === 'string';
        })
            .map(function (_a) {
            var key = _a[0], val = _a[1];
            return "".concat(baseClass, "-").concat(key, "-").concat(val);
        })
            .join(' '), type && "".concat(baseClass, "-").concat(UitkLayoutPositionTypes.get(type)), allowCustomPosition && "".concat(baseClass, "-custom"), className);
    var wrapperStyle = __assign(__assign({}, firstChildStyle), style);
    if (position && allowCustomPosition) {
        Object.entries(position).forEach(function (_a) {
            var key = _a[0], val = _a[1];
            if (typeof val === 'number') {
                wrapperStyle["--uitk-custom-".concat(key, "-position")] = "".concat(val, "px");
            }
        });
    }
    var decoratedChild = React.cloneElement(firstChild, __assign(__assign({ className: wrapperClassNames }, (Object.keys(wrapperStyle).length && {
        style: wrapperStyle
    })), attributes));
    var Tag = ((tag && UitkLayoutTags.get(tag)) || UitkLayoutTags.get('div'));
    return cloneElement ? (decoratedChild) : (React.createElement(Tag, __assign({ className: wrapperClassNames }, attributes, { style: wrapperStyle }),
        ' ',
        children || null,
        ' '));
};
UitkLayoutPosition.displayName = 'UitkLayoutPosition';

export { UitkLayoutPosition };
